import Vue from "vue";
import Vuex from "vuex";
import { account } from "./account";
import { app } from "./app";
import { IAccountState } from "./account/state";
import { IAppState } from "./app/state";

Vue.use(Vuex);

export interface IState {
    account: IAccountState;
    app: IAppState;
}

export const store = new Vuex.Store<IState>({
    modules: {
        account,
        app,
    },
});
